import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FirmLoginComponent } from './pages/firm-login/firm-login.component';
import { RootEntryComponent } from './pages/root-entry/root-entry.component';
import { SetpasswordComponent } from './pages/setpassword/setpassword.component';
import { TxnApprovalComponent } from './pages/txn-approval/txn-approval.component';
import { SblApprovalComponent } from './pages/sbl-approval/sbl-approval.component';
import { SblEmailComponent } from './pages/sbl-email/sbl-email.component';
import { CustomLendingDocZipDownloadComponent } from './pages/custom-lending-doc-zip-download/custom-lending-doc-zip-download.component';
import { AdvyzonCallbackComponent } from './pages/advyzon-callback/advyzon-callback.component';
import { environment } from '../environments/environment';

export const routes: Routes = [

  {
    path: '',
    pathMatch: 'full',
    component: RootEntryComponent,
  },
  {
    path: 'client-agreement-gate',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/client-agreement-gate/client-agreement-gate.component').then(
        (m) => m.ClientAgreementGateComponent
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth-layout/auth-layout.module').then(
        (m) => m.AuthLayoutModule
      ),
  },

  {
    path: 'advisor-dashboard',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import(
        './pages/advisor-dashboard-layout/advisor-dashboard-layout.module'
      ).then((m) => m.AdvisorDashboardLayoutModule),
    data: { role: ['advisor', 'client'] },
  },
  {
    path: 'admin-dashboard',
    loadChildren: () =>
      import(
        './pages/admin-dashboard-layout/admin-dashboard-layout.module'
      ).then((m) => m.AdminDashboardLayoutModule),
    canActivate: [MsalGuard],
    data: { role: 'admin' },
  },
  { path: 'txnApproval/:token', component: TxnApprovalComponent },
  { path: 'sblApproval/:token', component: SblApprovalComponent },
  {
    path: 'firmlogin/:firm/advisor-dashboard',
    redirectTo: '/advisor-dashboard',
    pathMatch: 'full',
  },
  {
    path: 'firmlogin/:firm/advisor-dashboard/user-management',
    redirectTo: '/advisor-dashboard/user-management',
    pathMatch: 'full',
  },
  { path: 'firmlogin', component: FirmLoginComponent },
  { path: 'firmlogin/:token/:roleType', component: FirmLoginComponent },
  { path: 'firmlogin/:token', component: FirmLoginComponent },
  { path: 'setpassword/:token', component: SetpasswordComponent },
  { path: 'advyzon-callback', component: AdvyzonCallbackComponent },
  { path: 'sblEmail', component: SblEmailComponent },
  { path: 'customLendingDocZipDownload/:token', component: CustomLendingDocZipDownloadComponent },
  {
    // Developer tool for inspecting encrypted payloads; never matched in prod.
    path: 'dev/crypto-tools',
    canMatch: [() => environment.env !== 'prod'],
    loadComponent: () =>
      import('./pages/crypto-tools/crypto-tools.component').then((m) => m.CryptoToolsComponent),
  },
];

